<app-request-an-insurance-quote mainHeading="QUOTE REQUEST" subHeading="false"></app-request-an-insurance-quote>
<!-- START OF FORM -->
<form (ngSubmit)="onSubmit(homeForm)" #homeForm="ngForm" autocomplete="off">
    <section id="rtq-form" class="pb-5">
        <div class="container">
            <img src="assets/img/PRELOADER.gif" class="preloader" *ngIf="isLoading" />
            <div class="row justify-content-center">
                <div class="col-md-7 col-xs-12">
                    <p *ngIf="isHO3 && !this.dataService.leadDetails.isServiceUnavailable"> We found some information
                        to
                        save your time! Please review and change anything that is incorrect.
                    </p>
                    <p *ngIf="isH04orDQdndRUN && !this.dataService.leadDetails.isServiceUnavailable">
                        Please provide us with some information about your home.

                    </p>

                    <span id="messageError" class="text-uppercase service-error-message"
                        *ngIf="isInavlidPropertyType && !this.dataService.leadDetails.isServiceUnavailable"
                        [innerHTML]="leadDetails.homeInfo.message">
                    </span>

                    <span class="pl-3"
                        *ngIf="isHO3 || isH04orDQdndRUN || dataService.leadDetails.isServiceUnavailable">Home
                        Information</span>
                    <br>
                    <br>
                    <div class="form-div z-indexHeader"
                        *ngIf="!this.dataService.leadDetails.isServiceUnavailable && !leadDetails.homeInfo.inValidPropertyType">
                        <div class="row pt-3">
                            <div class="col">
                                <label for="lblHomebuilt">What year was the home built? <span> *</span></label>
                                <input type="text" class="form-control home-textbox" id="txtHomeBuilt"
                                    [ngModelOptions]="{ updateOn: 'blur' }" required
                                    [(ngModel)]="leadDetails.homeInfo.yearBuild" name="yearBuild" #yearBuild="ngModel"
                                    maxlength="4" customMin="{{this.minYearBuild}}" customMax="{{this.maxYearBuild}}"
                                    OnlyNumber>
                                <label *ngIf="(yearBuild.hasError('required') && yearBuild.touched) "
                                    class="error-message text-nowrap">
                                    {{constantObj.requiredErrorMessage}}
                                </label>
                                <label
                                    *ngIf="(yearBuild.errors?.customMin && yearBuild.touched && !yearBuild.hasError('required'))"
                                    class="error-message text-nowrap">
                                    Minimum required value is {{minYearBuild}}
                                </label>
                                <label
                                    *ngIf="(yearBuild.errors?.customMax && yearBuild.touched && !yearBuild.hasError('required'))"
                                    class="error-message text-nowrap">
                                    Maximum required value is {{maxYearBuild}}
                                </label>
                            </div>
                        </div>
                        <div class="row pt-3">
                            <div class="col">
                                <label for="lblSquareFootage">What is the square footage of the home?
                                    <span>*</span></label>
                                <input type="text" class="form-control home-textbox" id="txtSquareFootage"
                                    [ngModelOptions]="{ updateOn: 'blur' }" required
                                    [(ngModel)]="leadDetails.homeInfo.squareFootage" OnlyNumber name="squareFootage"
                                    maxlength="4" #squareFootage="ngModel">
                                <label *ngIf="(squareFootage.hasError('required') && squareFootage.touched) "
                                    class="error-message">
                                    {{constantObj.requiredErrorMessage}} </label>
                            </div>
                        </div>
                        <div class="row pt-3">
                            <div class="col">
                                <label for="lblMaterial">What kind
                                    of
                                    material is the home made of? <span>*</span></label>
                                <select class="form-control home-width-select" id="txtConstructionType"
                                    [ngModelOptions]="{ updateOn: 'blur' }" required
                                    [(ngModel)]="leadDetails.homeInfo.constructionType" name="homeType"
                                    #constructionType="ngModel">
                                    <option selected [ngValue]="''"></option>
                                    <option *ngFor="let item of leadDetails.homeInfo.lstConstructionType"
                                        [value]="item.lookupId">{{item.lookupValue}}</option>
                                </select>
                                <label *ngIf="(constructionType.hasError('required') && constructionType.touched) "
                                    class="error-message">
                                    {{constantObj.requiredErrorMessage}} </label>
                            </div>
                        </div>
                        <div class="row pt-3">
                            <div class="col">
                                <label for="lblMaterial">What type of residence is the home? <span>*</span></label>
                                <select class="form-control home-width-select" id="txtHomeType"
                                    [ngModelOptions]="{ updateOn: 'blur' }" required
                                    [(ngModel)]="leadDetails.homeInfo.homeType" name="residanceType" #homeType="ngModel"
                                    [disabled]="DisableHomeTypeforHO4()">
                                    <option selected [ngValue]="''"></option>
                                    <option *ngFor="let item of leadDetails.homeInfo.lstHomeType"
                                        [value]="item.lookupId">{{item.lookupValue}}</option>
                                </select>
                                <label *ngIf="(homeType.hasError('required') && homeType.touched) "
                                    class="error-message">{{constantObj.requiredErrorMessage}}</label>
                            </div>
                        </div>
                        <div class="row pt-3">
                            <div class="col">
                                <label for="Email">What type of property is the home? <span> *</span></label>
                                <select class="form-control home-width-select" id="txtPropertytype"
                                    [ngModelOptions]="{ updateOn: 'blur' }" required
                                    [(ngModel)]="leadDetails.homeInfo.propertyType" name="propertyType"
                                    #propertyType="ngModel">
                                    <option selected [ngValue]="''"></option>
                                    <option *ngFor="let item of leadDetails.homeInfo.lstPropertyType"
                                        [value]="item.lookupId">{{item.lookupValue}}</option>
                                </select>
                                <label *ngIf="(propertyType.hasError('required') && propertyType.touched) "
                                    class="error-message">{{constantObj.requiredErrorMessage}}
                                </label>
                            </div>
                        </div>

                        <!-- Start logical order -->
                        <div class="row pt-3">
                            <div class="col-md-6 pl-0 pr-0">
                                <div class="col-md-12">
                                    <label for="lblNoOfBedrooms">Number of Bedrooms</label>
                                    <input type="text" class="form-control home-textbox" id="txtNoOfBedrooms"
                                        [(ngModel)]="leadDetails.homeInfo.noOfBedrooms" name="NoOfBedrooms"
                                        #noOfBedrooms="ngModel" (keypress)="_keyUp($event)"
                                        (blur)="formatBedrooms($event)" />
                                </div>
                                <div class="col-md-12 pt-3">
                                    <label for="lblNoOfBathrooms">Number of Bathrooms </label>
                                    <input type="text" (keypress)="_keyUp($event)" (blur)="formatBathrooms($event)"
                                        class="form-control home-textbox" id="txtNoOfBathroms"
                                        [ngModelOptions]="{ updateOn: 'blur' }"
                                        [(ngModel)]="leadDetails.homeInfo.noOfBathRooms" name="noOfBathRooms"
                                        #noOfBathRooms="ngModel">
                                </div>
                                <div class="col-md-12 pt-3">
                                    <label for="lblNoOfStories">Number
                                        of Stories <span>*</span></label>
                                    <input type="text" class="form-control home-textbox" id="txtNoOfStories"
                                        [ngModelOptions]="{ updateOn: 'blur' }" required
                                        [(ngModel)]="leadDetails.homeInfo.noOfStories" name="noOfStories" maxlength="10"
                                        #noOfStories="ngModel" OnlyNumber>
                                    <label *ngIf="(noOfStories.hasError('required') && noOfStories.touched) "
                                        class="error-message">{{constantObj.requiredErrorMessage}}</label>
                                </div>
                                <div class="col-md-12 pt-3">
                                    <label for="lblNoOfFire">Number
                                        of Fireplaces</label>
                                    <input type="text" class="form-control home-textbox" id="txtNoOffire"
                                        [ngModelOptions]="{ updateOn: 'blur' }"
                                        [(ngModel)]="leadDetails.homeInfo.noOfFirePlaces" name="noOfFirePlaces"
                                        #noOfFirePlaces="ngModel" maxlength="5" OnlyNumber>
                                </div>
                                <div class="col-md-12 pt-3">
                                    <label for="lblNoOfUnits">Number of Units</label>
                                    <select class="form-control ddlNoUnits" id="txtUnitNumber"
                                        [ngModelOptions]="{ updateOn: 'blur' }"
                                        [(ngModel)]="leadDetails.homeInfo.unitNumber" name="unitNumber"
                                        #unitNumber="ngModel">
                                        <option selected [ngValue]="''"></option>
                                        <option *ngFor="let item of leadDetails.homeInfo.lstUnitNumber"
                                            [value]="item.lookupId">{{item.lookupValue}}</option>
                                    </select>
                                </div>
                                <div class="col-md-12 pt-3">
                                    <label for="lblFoundation">Foundation
                                        Type <span> *</span></label>
                                    <select class="form-control home-width-select" id="txtFoundationType"
                                        [ngModelOptions]="{ updateOn: 'blur' }"
                                        [(ngModel)]="leadDetails.homeInfo.foundationType"
                                        (ngModelChange)="SetFoundationType()" name="foundationtype"
                                        #foundationType="ngModel" required>
                                        <option selected [ngValue]="''"></option>
                                        <option *ngFor="let item of leadDetails.homeInfo.lstFoundationType"
                                            [value]="item.lookupId">{{item.lookupValue}}</option>
                                    </select>
                                    <label
                                        *ngIf="(foundationType.hasError('required') && foundationType.touched)"
                                        class="error-message">{{constantObj.requiredErrorMessage}}</label>

                                </div>

                                <!-- Foundationtype need to added -->
                                <div class="col-md-12 pt-3"
                                    *ngIf="leadDetails.homeInfo.foundationType=='3C6214293EC04BF283ECEA9AFB3D34A7'">
                                    <label for="lblNoOfStories">% Finished<span> *</span></label>
                                    <select class="form-control ddlNoUnits " id="ddlPercentageFinished"
                                        [ngModelOptions]="{ updateOn: 'blur' }"
                                        [(ngModel)]="leadDetails.homeInfo.percentageFinished" name="PercentageFinished"
                                        #percentageFinished="ngModel" required>
                                        <option selected [ngValue]="''"></option>
                                        <option *ngFor="let item of leadDetails.homeInfo.lstPercentageFinished"
                                            [value]="item.lookupId">{{item.lookupValue}}</option>
                                    </select>
                                    <label
                                        *ngIf="(percentageFinished.hasError('required') && percentageFinished.touched)"
                                        class="error-message">{{constantObj.requiredErrorMessage}}</label>

                                </div>

                            </div>
                            <div class="col-md-6 pl-0 pr-0">
                                <div class="col-md-12 mob-pt-3">
                                    <label for="lblGaPgeType">Garage Type</label>
                                    <select class="form-control home-width-select" id="txtGaragetype"
                                        [(ngModel)]="leadDetails.homeInfo.garageType" name="garageType"
                                        #garageType="ngModel" (ngModelChange)="setGarageSize()">
                                        <option selected [ngValue]="''"></option>
                                        <option *ngFor="let item of leadDetails.homeInfo.lstGarageType"
                                            [value]="item.lookupId">{{item.lookupValue}}</option>
                                    </select>
                                </div>
                                <div class="col-md-12 pt-3">
                                    <label for="lblGarageSize">Garage
                                        Size </label>
                                    <select class="form-control ddlNoUnits" id="txtGaragesize"
                                        [ngModelOptions]="{ updateOn: 'blur' }"
                                        [(ngModel)]="leadDetails.homeInfo.garageSize"
                                        [disabled]="leadDetails.homeInfo.garageType == constantObj.GarageType_None"
                                        name="garageSize" #garageSize="ngModel">
                                        <option selected [ngValue]="''"></option>
                                        <option *ngFor="let item of leadDetails.homeInfo.lstGarageSize"
                                            [value]="item.lookupId">{{item.lookupValue}}</option>
                                    </select>
                                </div>


                                <div class="col-md-12 pt-3">
                                    <label for="lblRoofType">Roof
                                        Type<span> *</span></label>
                                    <select class="form-control home-width-select" id="txtRoofType"
                                        [ngModelOptions]="{ updateOn: 'blur' }" required
                                        [(ngModel)]="leadDetails.homeInfo.roofType" name="roofType" #roofType="ngModel">
                                        <option selected [ngValue]="''"></option>
                                        <option *ngFor="let item of leadDetails.homeInfo.lstRoofType"
                                            [value]="item.lookupId">{{item.lookupValue}}</option>
                                    </select>
                                    <label *ngIf="(roofType.hasError('required') && roofType.touched) "
                                        class="error-message">{{constantObj.requiredErrorMessage}}</label>
                                </div>

                                <div class="col-md-12 pt-3">
                                    <label for="lblRoofShape">Roof Shape</label>
                                    <select class="form-control home-width-select" id="txtRoofShape"
                                        [ngModelOptions]="{ updateOn: 'blur' }"
                                        [(ngModel)]="leadDetails.homeInfo.roofShape" name="roofShape"
                                        #roofShape="ngModel">
                                        <option selected [ngValue]="''"></option>
                                        <option *ngFor="let item of leadDetails.homeInfo.lstRoofShape"
                                            [value]="item.lookupId">{{item.lookupValue}}</option>
                                    </select>
                                </div>

                                <div class="col-md-12 pt-3">
                                    <label for="lblSolarPanel">Solar Panel</label>
                                    <select class="form-control home-width-select" id="txtSolarPanel"
                                        [ngModelOptions]="{ updateOn: 'blur' }"
                                        [(ngModel)]="leadDetails.homeInfo.solarPanel" name="solarPanel"
                                        #solarPanel="ngModel">
                                        <option selected [ngValue]="''"></option>
                                        <option *ngFor="let item of leadDetails.homeInfo.lstSolarPanel"
                                            [value]="item.lookupId">{{item.lookupValue}}</option>
                                    </select>
                                </div>
                                <div class="col-md-12 pt-3">
                                    <label for="lblWaterSensor">Water Sensor</label>
                                    <select class="form-control home-width-select" id="txtWaterSensor"
                                        [ngModelOptions]="{ updateOn: 'blur' }"
                                        [(ngModel)]="leadDetails.homeInfo.waterSensor" name="waterSensor"
                                        #waterSensor="ngModel">
                                        <option selected [ngValue]="''"></option>
                                        <option *ngFor="let item of leadDetails.homeInfo.lstWaterSensor"
                                            [value]="item.lookupId">{{item.lookupValue}}</option>
                                    </select>
                                </div>

                            </div>

                        </div>
                        <!-- End logical order -->
                    </div>

                    <div class="row pt-4"
                        *ngIf="!isInavlidPropertyType && !this.dataService.leadDetails.isServiceUnavailable">
                        <p class="req-msg-note pl-3">*These fields are required</p>
                    </div>

                    <!-- Button -->
                    <div class="row  pt-3"
                        *ngIf="!isInavlidPropertyType && !this.dataService.leadDetails.isServiceUnavailable">
                        <div class="col">
                            <button type="button" tabindex="-1"
                                class="btn angled-button-sm button-width-110 button-align-mob-previous previous-left"
                                (click)="commonService.NavigateToPage('/real-time-quote/credit-auth')">
                                <span>Previous</span>
                            </button>
                        </div>
                        <div class="col">
                            <button type="submit" class="btn angled-button-sm button-align-mob-next btn-next-120">
                                <span>Next</span>
                            </button>
                        </div>
                    </div>
                    <div class="row pt-3">
                        <button type="button" class="btn angled-button-sm button-width-190 button-align-mob-center"
                            (click)="this.popUp.openModal()">
                            <span>Please contact me</span>
                        </button>
                    </div>
                    <!-- // Button -->
                </div>
            </div>
        </div>
    </section>

    <app-model-popup (savePageDetails)="savePageDetails()"></app-model-popup>
</form>
<!-- //END OF FORM -->